import {TYPE_SET_MESSAGES} from "app/redux/chats&notifications/chatsTypes";

export const actionSetMessages = (chat, data) => ({
  type: TYPE_SET_MESSAGES,
  payload: {
    chat,
    data,
  },
});
